import React from 'react'
import './Wgbs.css'

import { FaChevronRight } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';

function Wgbs() {
  
    const navigate = useNavigate();

  return (
    <section className='wgbs-sec'>
        <div className='container'>
            <h3>Why Build SaaS </h3>
            <h4>with 360 Gigabytes?            </h4>
            <p className='plg'>
We combine product sensibility with engineering rigor. Our experience building repeatable SaaS patterns shortens time to market, reduces operating costs, and gives you the controls businesses expect from mature cloud products.
</p>
            <p className='plg'>Monetization and Support <br/>
Subscription tiers, usage-based pricing, enterprise plans with SSO and custom SLAs, and ongoing technical and customer success support.

            </p>
            <p className='plg'>If you want a SaaS product that customers adopt, pay for, and recommend, we can build it together.  </p>

            <button className='btn-main' onClick={() => navigate('/contact')}><span>Contact Us</span> <FaChevronRight/></button>
        </div>

    </section>
  )
}

export default Wgbs
